const defaultState = () => {
  return {
    stream: null,
    isStreamOwner: false,
    // 誰かが画面共有した際の自身へのMediaConnection
    displayCall: null
  }
}

const state = defaultState()

const getters = {
  projector: state => {
    return {
      stream: state.stream,
      isStreamOwner: state.isStreamOwner,
      displayCall: state.displayCall
    }
  }
}

const mutations = {
  setStream(state, payload) {
    const { stream, isStreamOwner } = payload

    state.stream = stream
    state.isStreamOwner = isStreamOwner
  },
  removeStream(state) {
    if (state.stream) {
      state.stream.getTracks().forEach(track => {
        track.stop()
      })
    }
    state.stream = null
    state.isStreamOwner = false
    if (state.displayCall) {
      state.displayCall.close()
      state.displayCall = null
    }
  },
  setDisplayCall(state, displayCall) {
    state.displayCall = displayCall
  },
  removeDisplayCall(state) {
    state.displayCall.close()
    state.displayCall = null
  },
  resetModule(state) {
    Object.assign(state, defaultState())
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
